/* eslint-disable no-nested-ternary */
import React from 'react';

import { Dialog } from '@mui/material';

import { useMyInterestDialog } from './my-interest-dialog.hook';
import MyInterestQuiz from './my-interest-dialog-steps/my-interest-quiz';
import MyInterestInvite from './my-interest-dialog-steps/my-interest-invite';

export interface MyInterestDialogProps {
  open: boolean
}


export default function MyInterestDialog({ open }: MyInterestDialogProps) {
  const {
    startQuiz,
    sendingMyInterests,
    handleCloseDialog,
  } = useMyInterestDialog();

  const content = () => {
    if (startQuiz.value) {
      return <MyInterestQuiz sendingMyInterests={sendingMyInterests} handleCloseDialog={handleCloseDialog} />
    }
    return <MyInterestInvite startQuiz={startQuiz} handleCloseDialog={handleCloseDialog} />
  }

  return (
    <Dialog open={open} fullScreen >
      {content()}
    </Dialog >
  )
}
